import { render } from "./BFormSelect.vue?vue&type=template&id=9da86ace&scoped=true"
import script from "./BFormSelect.vue?vue&type=script&lang=js"
export * from "./BFormSelect.vue?vue&type=script&lang=js"

import "./BFormSelect.vue?vue&type=style&index=0&id=9da86ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da86ace"]])

export default __exports__